<template>
  <div class="image-previewer-wrapper" v-show="showPreviewer" @mousewheel="handleMouseWheel">
    <div class="image-wrapper">
      <img
        class="image-preview"
        :style="{transform: `scale(${zoom}) rotate(${rotate}deg)`}"
        :src="previewUrl"
        @click="close"
      />
    </div>
    <van-icon class="close-button" name="cross" @click="close" />
    <van-icon class="prev-button" name="arrow-left" @click="goPrev"></van-icon>
    <van-icon class="next-button" name="arrow" @click="goNext"></van-icon>
    <div class="actions-bar">
      <van-icon :name="require('../image/Minus.png')" @click="zoomOut" />
      <van-icon name="plus" @click="zoomIn"></van-icon>
      <van-icon name="replay" style="transform: rotateY(180deg);" @click="rotateLeft"></van-icon>
      <van-icon name="replay" @click="rotateRight"></van-icon>
      <div class="image-counter">{{index+1}} / {{imgUrlList.length}}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Icon } from 'vant'

export default {
  name: 'ImagePreviewer',
  components: {
    VanIcon: Icon
  },
  data () {
    return {
      url: '',
      index: 0,
      visible: false,
      zoom: 1,
      rotate: 0,
      minZoom: 0.1,
      urlFlag: false
    }
  },
  computed: {
    ...mapGetters('chat', ['imgUrlList']),
    showPreviewer () {
      return this.url.length > 0 && this.visible
    },
    imageStyle () {
      return {
        transform: `scale(${this.zoom});`
      }
    },
    previewUrl () {
      if (this.urlFlag) {
        return this.url
      } else {
        return this.formatUrl(this.imgUrlList[this.index])
      }
      // this.urlFlag ? return this.url :
    }
  },
  mounted () {
    this.$bus.$on('image-preview', this.handlePreview)
  },
  methods: {
    handlePreview ({ url, flag = undefined }) {
      this.url = url
      this.urlFlag = flag ? 'merger' : false
      this.index = this.imgUrlList.findIndex(item => item === url)
      this.visible = true
    },
    handleMouseWheel (event) {
      if (event.wheelDelta > 0) {
        this.zoomIn()
      } else {
        this.zoomOut()
      }
    },
    zoomIn () {
      this.zoom += 0.1
    },
    zoomOut () {
      this.zoom =
        this.zoom - 0.1 > this.minZoom ? this.zoom - 0.1 : this.minZoom
    },
    close () {
      Object.assign(this, { zoom: 1 })
      this.visible = false
    },
    rotateLeft () {
      this.rotate -= 90
    },
    rotateRight () {
      this.rotate += 90
    },
    goNext () {
      this.index = (this.index + 1) % this.imgUrlList.length
    },
    goPrev () {
      this.index =
        this.index - 1 >= 0 ? this.index - 1 : this.imgUrlList.length - 1
    },
    formatUrl (url) {
      if (!url) {
        return ''
      }
      return url.slice(0, 2) === '//' ? `https:${url}` : url
    }
  }
}
</script>

<style scoped>
.image-previewer-wrapper {
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  background: rgba(14, 12, 12, 0.7);
  z-index: 2000;
  cursor: zoom-out;
}

.close-button {
  cursor: pointer;
  font-size: .36rem;
  color: #000;
  position: fixed;
  top: .5rem;
  right: .5rem;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  padding: .12rem;
}
.image-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.image-preview {
  transition: transform 0.1s ease 0s;
}
.actions-bar {
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: fixed;
  bottom: 1rem;
  left: 50%;
  margin-left: -2rem;
  padding: .24rem;
  border-radius: .12rem;
  background: rgba(255, 255, 255, 0.8);
}
.actions-bar i {
  font-size: .4rem;
  cursor: pointer;
  margin: 0 .12rem;
}

.prev-button,
.next-button {
  position: fixed;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  font-size: .48rem;
  padding: .24rem;
}
.prev-button {
  left: 0;
  top: 50%;
}
.next-button {
  right: 0;
  top: 50%;
}
.image-counter {
  background: rgba(20, 18, 20, 0.53);
  padding: .06rem;
  border-radius: .06rem;
  color: #fff;
  font-size: .26rem;
}
</style>
